import scrollFrame from "../../setup/js/_scrollFrame.2";
import scrollWatch from "../../setup/js/_scrollWatch.2";
$(document).on("tqht_mansite_newworld rendered", {}, function (event, uniqueId) {
  var $this = $("#" + uniqueId);
  var menu = [];
  // console.log(event);
  // console.log(uniqueId);
  // console.log($this);
  // if ($("#blockHomenewworldSwiper").length > 0) {
  //   $("#blockHomenewworldSwiper .swiper-wrapper .swiper-slide").each(function () {
  //     var textpaging = $(this).data('text');
  //     menu.push(textpaging);
  //   });

    const swiperContainer = $("#blockHomenewworldSwiper");
    if (swiperContainer.length > 0) {
      const menu = [];
    
      swiperContainer.find(".swiper-slide").each(function () {
        menu.push($(this).data("text"));
      });
    
      // Fix lỗi: Đảm bảo dùng đúng hàm `new Swiper` thay vì `initSwiper`
      const swiperContainerTinhNang = new Swiper("#blockHomenewworldSwiper", {
        slidesPerView: 1,
        centeredSlides: true,
        loop: true,
        effect: "coverflow",
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 0,
          modifier: 1,
          slideShadows: false,
        },
        lazy: {
          loadPrevNext: true,
        },
        pagination: {
          el: ".swiper-pagination--newworldSwiper",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          769: {
            slidesPerView: "auto",
            coverflowEffect: {
              rotate: 0,
              stretch: 630,
              depth: 315,
              modifier: 1,
              slideShadows: false,
            },
          },
        },
      });
    }
    

});